import { z } from "zod"
import { DurationSchema, TimelineSchema, PositionSchema } from "./timing"

export const GifMediaInfoSchema = z.object({
  mediaType: z.literal("video").default("video"),
  originUrl: z.string(),
  previewUrl: z.string(),
  width: z.number().default(0),
  height: z.number().default(0),
  sourceId: z.string().default(""),
  duration: z.number().default(0),
  source: z.string().default(""),
  quote: z.string().default(""),
})

export const GifAudioSettingsSchema = z.object({
  volume: z.number().min(0).max(100).default(100),
  fadeInMs: z.number().default(0),
  fadeOutMs: z.number().default(200),
  duckOriginalAudio: z.boolean().default(true),
  duckLevel: z.number().min(0).max(100).default(0),
})

export const GifContentSchema = z.object({
  id: z.string(),
  gifType: z.literal("Vlipsy").default("Vlipsy"),
  mediaInfo: GifMediaInfoSchema,
  audioSettings: GifAudioSettingsSchema.default({}),
})

export const DEFAULT_GIF_POSITION = {
  type: "CPct" as const,
  xPct: 0.0,
  yPct: 0.5,
  wPct: 0.55,
  hPct: 0.22,
}

export const GifSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("Gif"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  trimStartMs: z.number().optional().describe("Where this piece starts in its media (ms); set when a segment is split"),
  content: GifContentSchema,
  position: PositionSchema.optional(),
  pending: z.boolean().optional().describe("Client-only: added in the editor, not yet confirmed (and billed) by the backend; never saved"),
})

export type GifMediaInfo = z.infer<typeof GifMediaInfoSchema>
export type GifAudioSettings = z.infer<typeof GifAudioSettingsSchema>
export type GifContent = z.infer<typeof GifContentSchema>
export type GifSegment = z.infer<typeof GifSegmentSchema>

/** @deprecated Use GifSegment instead */
export type GifSegmentType = GifSegment
